import { IGameWithParams } from './game.models';

/**
 * Sets the game ID for the game that the user is currently processing
 */
export class SetGameId {
    public static readonly type = '[Game] SetGameId';
    constructor(public gameId: string) { }
}

export class FetchGameForId {
    public static readonly type = '[Game] FetchGameForId';
    constructor(public gameId: string, public params?: IGameWithParams) { }
}

export class FetchVidParamsForGame {
    public static readonly type = '[Game] FetchVidParamsForGame';
    constructor(public gameId: string) { }
}
